import styled from "styled-components";

export const ProductNav = styled.div`
	display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
	flex-wrap: wrap;
    justify-content: start;
	align-items: center;
    align-content: center;
    margin-bottom: 1%;
    padding-right: 2%;
    cursor: auto;
    width: 80vw;
`;

export const ProductRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: flex-end;
    z-index: 1;
    padding-inline:15px;
`;

export const ProductContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    text-align: start;
`;

export const ProductTitle = styled.div`
    color: #0071CE;
    font-size: 0.9vw;
    margin-left: 10%;
    margin-bottom: 10%;
`;

export const ProductBody = styled.div`
    color: #565656;
    font-size: 0.9vw;
    margin-left: 10%;
    margin-bottom: 5%;
    cursor: text;
    font-style: normal;
    font-weight: 400;
`;

export const ProductImage = styled.img`
    width: 7vw;
    height: 10%;
`;